import React, { useMemo } from 'react'
import i18n from 'i18next'
import { gql, useQuery } from '@apollo/client'
import { useSites } from 'store'

import FilterSelectMulti from 'packages/ui/FilterSelectMulti'
import * as countries from 'i18n-iso-countries'
import { useTranslation } from 'react-i18next'

const COUNTRIES_OPERATION = gql`
  query PortalUsersCountries($createdAtStart: String, $createdAtEnd: String, $siteSfIds: [ID!]) {
    countries: portalUsersCountries(created_at_start: $createdAtStart, created_at_end: $createdAtEnd, site_sf_ids: $siteSfIds) {
      key
      count
    }
  }
`
type CountryQueryType = {
  countries: {key: string, count: number}[]
}
interface CountriesProps {
  onChange: (countries: string[]) => void
  selection: string[]
}
const Countries: React.FC<CountriesProps> = ({onChange, selection}) => {
  const {t} = useTranslation()
  const [{ selected }] = useSites()
  const siteSfIds = useMemo(
    () => (selected ? selected.map(({ sf_id }) => sf_id) : []),
    [selected],
  )
  const { data, loading } = useQuery<CountryQueryType>(COUNTRIES_OPERATION, {
    variables: {
      siteSfIds
    }
  })
  const options = useMemo(() => {
    if (!data) {
      return []
    }
    return data.countries.map(country => ({
      label: countries.getName(country.key.toLowerCase(), i18n.language),
      value: country.key,
      count: country.count
    }))
  }, [data])

  return (
    <FilterSelectMulti
      options={options}
      onChange={onChange}
      values={selection}
      placeholder={loading ? '...' : t('statistics.filters.countries')}
    />
  )
}


export default Countries;